import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { DIALOG_KEYS } from "constants/dialogKeys"
import { enqueueGlobalDialog } from "appRedux/slices/globalSlice"

export function useServiceWorker() {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "NEW_VERSION_AVAILABLE") {
          setUpdateAvailable(true)
          dispatch(enqueueGlobalDialog(DIALOG_KEYS.UPDATE_AVAILABLE_REMINDER))
        }

        if (event.data?.type === "UPDATE_BADGE" && navigator?.setAppBadge) {
          const count = event.data.count
          navigator.setAppBadge(count)
            .then(() => console.debug(`App badge has been set to ${count}`))
            .catch((error: any) => console.error(`Error setting badge to ${count} in useServiceWorker hook. Error: ${error}`))
        }
      })
    }
  }, [])

  return { updateAvailable, setUpdateAvailable }
}
